import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { isAdminUser } from "../../utils/auth";

function ProtectedRouteAdmin({ isSignedIn,
                                 // requiredRoles,
                                 children }) {
    const { user } = useSelector((state) => state.auth);
    // const userRole = user.user.role;
    if (isSignedIn) {
        if (!isAdminUser(user)){
            return <Navigate to="/"/>;
        }
        return children;
    } else {
        return <Navigate to="/admin/login"/>;
    }
}

export default ProtectedRouteAdmin;
